export default {
  SET_ITEMS(state, payload) {
    state.departements = payload
  },

}
